export default {
	fields: {
		name: 'Jméno',
		email: 'E-mail',
		question: 'Dotaz',
	},
	submit_button: 'Odeslat',
	question_submitted: 'Dotaz byl odeslán',
};
